import { checkPermissions } from "../../../helpers/checkPermissions";

/**
 * Reads every localized and legacy URL shape owned by the Niffler admin app.
 */
export const read_is_niffler_admin_path = (pathname = "") => {
    return /^\/(?:[^/]+\/)?akihiko\/niffler(?:\/|$)/i.test(`${pathname || ""}`.trim());
};

/**
 * Hides CRM quest navigation from Scout-and-above users while they are inside Niffler.
 */
export const read_hide_admin_quest_navigation = (pathname = "", userRoles = []) => {
    return read_is_niffler_admin_path(pathname) && checkPermissions("Scout", userRoles);
};

/**
 * Shows admin-only sidebar sections to Scout-and-above users.
 */
export const read_show_admin_stats_navigation = (userRoles = []) => {
    return checkPermissions("Scout", userRoles);
};
